import {trackClicks} from "./helpers/track-clicks";
import {initBookFloat} from "./book-float";

const CapesHeader = {
  toggler: null,
  header: null,
  mobNav: null,
  mobileChatLauncher: null,
  zohoChatLaunchRequested: false,
  zohoChatReadyBound: false,
  zohoChatRetryCount: 0,
  zohoChatRetryTimeout: null,
  selected: null,
  featured: null,
  drop: null,
  selectedMenu: null,
  selectedItem: null,

  initMenu() {
    this.toggler = document.querySelector(".js-menu-toggler")
    this.mobNav = document.querySelector(".js-nav-wrap")
    this.drop = document.querySelector(".drop")
    this.header = document.querySelector("#main-header")
    this.selected = document.querySelector("#selected-item")
    this.featured = document.querySelector("#featured-item")
    this.selectedMenu = document.querySelector("#tablet-sub-menu")
    this.items = document.querySelectorAll(".menu-item")
    this.parents = document.querySelectorAll(".menu-item-parent")

    this.initToggle()
    this.initActiveStates()
    this.initZohoMobileChat()

    if (this.isMobile()) {
      this.initMobileMenu()
    } else {
      this.initChevrons()
      this.initDropdownMenus()
      this.initExperiencesMenuPositioning()
    }
  },

  initChevrons() {
    if (window.innerWidth >= 1024) {
      const visitExperiencesItem = document.querySelector("nav li.attractionsMenu > a")

      if (visitExperiencesItem) {
        this.handleMegaMenuChevron(visitExperiencesItem)
      }

      return { visitExperiencesItem }
    }

    return { visitExperiencesItem: null }
  },

  menuIdToNavText(menuId) {
    // "aboutUsMenu" → "about us", "learnMenu" → "learn"
    return menuId.replace(/Menu$/, "").replace(/([A-Z])/g, " $1").trim().toLowerCase()
  },

  toggleChevron(menuItem, isOpen) {
    const chevronDown = menuItem.querySelector(".menu-chevron-down")
    const chevronUp = menuItem.querySelector(".menu-chevron-up")

    if (chevronDown && chevronUp) {
      if (isOpen) {
        chevronDown.classList.add("hidden")
        chevronUp.classList.remove("hidden")
        chevronUp.classList.add("chevron-active")
      } else {
        chevronUp.classList.add("hidden")
        chevronDown.classList.remove("hidden")
        chevronUp.classList.remove("chevron-active")
      }
    }
  },

  handleMegaMenuChevron(visitExperiencesItem) {
    const megaMenu = document.getElementById("megaMenu")

    if (megaMenu) {
      visitExperiencesItem.addEventListener("mouseenter", () => {
        this.toggleChevron(visitExperiencesItem, true)
      })

      visitExperiencesItem.addEventListener("mouseleave", () => {
        setTimeout(() => {
          if (!megaMenu.classList.contains("mm-show")) {
            this.toggleChevron(visitExperiencesItem, false)
          }
        }, 300)
      })

      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            const isOpen = megaMenu.classList.contains("mm-show")
            this.toggleChevron(visitExperiencesItem, isOpen)
          }
        })
      })

      observer.observe(megaMenu, { attributes: true })
    }
  },

  initDropdownMenus() {
    setTimeout(() => {
      document.querySelectorAll(".drop-menu").forEach((menu) => {
        const menuItemsEl = document.getElementById(menu.id + "Items")
        if (!menuItemsEl) return

        const navItemLabel = menu.dataset.menu;
        const navLink = Array.from(document.querySelectorAll("nav a")).find((link) =>
          link.textContent.trim().toLowerCase().includes(navItemLabel.trim().toLowerCase()),
        );

        if (!navLink) return

        const parentLi = navLink.closest("li")
        const submenu = parentLi ? parentLi.querySelector(".sub-menu, ul") : null

        if (!submenu) return

        const submenuItems = submenu.querySelectorAll("li > a")
        if (submenuItems.length === 0) return

        const positionMenu = () => {
          const rect = navLink.getBoundingClientRect()
          const headerRect = document.getElementById("main-header").getBoundingClientRect()
          const menuItemCenter = rect.left + rect.width / 2 - headerRect.left
          const cardLeft = menuItemCenter - 414 / 2
          menu.style.left = cardLeft + "px"
        }

        if (window.innerWidth >= 1024) {
          submenu.style.display = "none"
        }

        menuItemsEl.innerHTML = ""

        submenuItems.forEach((item) => {
          const menuItem = document.createElement("div")
          menuItem.className = "drop-menu-item"
          menuItem.innerHTML = `
            <a class="group flex gap-4" href="${item.href}">
              <span class="flex group-hover:underline">${item.textContent}</span>
              <img class="opacity-0 group-hover:opacity-100 transition-opacity" width="18" height="18"
              src="/wp-content/themes/capes/assets/images/icons/arrow-right-footer.svg" alt="right arrow" loading="lazy">
            </a>
          `
          menuItemsEl.appendChild(menuItem)
        })

        if (window.innerWidth >= 1024) {
          let hoverTimeout
          let openTimeout

          navLink.addEventListener("mouseenter", () => {
            clearTimeout(hoverTimeout)
            openTimeout = setTimeout(() => {
              positionMenu()
              menu.classList.remove("hidden")
              this.toggleChevron(navLink, true)
            }, 300)
          })

          navLink.addEventListener("mouseleave", () => {
            clearTimeout(openTimeout)
            hoverTimeout = setTimeout(() => {
              menu.classList.add("hidden")
              this.toggleChevron(navLink, false)
            }, 300)
          })

          menu.addEventListener("mouseenter", () => {
            clearTimeout(hoverTimeout)
          })

          menu.addEventListener("mouseleave", () => {
            menu.classList.add("hidden")
            this.toggleChevron(navLink, false)
          })

          window.addEventListener("resize", () => {
            if (window.innerWidth >= 1024 && !menu.classList.contains("hidden")) {
              positionMenu()
            }
          })
        }
      })
    }, 100)
  },

  initExperiencesMenuPositioning() {
    setTimeout(() => {
      const megaMenu = document.getElementById("megaMenu")
      if (!megaMenu) return

      const visitItem = Array.from(document.querySelectorAll("nav a")).find((link) =>
        link.textContent
          .trim()
          .toLowerCase()
          .includes("visit experiences"),
      )
      if (!visitItem) return

      if (window.innerWidth >= 1024) {
        let hoverTimeout
        let openTimeout

        visitItem.addEventListener("mouseenter", () => {
          clearTimeout(hoverTimeout)
          // Stays set, so the art doesn't vanish while the menu fades out. An attribute, not a class,
          // as a class change would reset the chevron (see the observer above)
          megaMenu.dataset.art = "true"
          openTimeout = setTimeout(() => {
            megaMenu.classList.add("mm-show")
          }, 300)
        })

        visitItem.addEventListener("mouseleave", () => {
          clearTimeout(openTimeout)
          hoverTimeout = setTimeout(() => {
            megaMenu.classList.remove("mm-show")
          }, 300)
        })

        const attractionsMenu = document.getElementById("attractionsMenu")
        const menuBg = megaMenu.querySelector(".attractionsMenuBg")

        if (attractionsMenu) {
          attractionsMenu.addEventListener("mouseenter", () => {
            clearTimeout(hoverTimeout)
            clearTimeout(openTimeout)
          })

          attractionsMenu.addEventListener("mouseleave", () => {
            megaMenu.classList.remove("mm-show")
          })
        }

        if (menuBg) {
          menuBg.addEventListener("mouseenter", () => {
            megaMenu.classList.remove("mm-show")
          })
        }

        document.querySelectorAll("#top-nav > .menu-item").forEach((item) => {
          item.addEventListener("mouseenter", () => {
            if (!item.contains(visitItem)) {
              clearTimeout(openTimeout)
              megaMenu.classList.remove("mm-show")
            }
          })
        })
      }
    }, 100)
  },

  initActiveStates() {
    // Only apply active states on desktop
    if (window.innerWidth >= 1024) {
      const attempts = [100, 500, 1000]

      attempts.forEach((delay) => {
        setTimeout(() => {
          const activeSelectors = [
            ".current_page_item",
            ".current-menu-item",
            ".current_page_parent",
            ".current-menu-parent",
            ".current_page_ancestor",
            ".current-menu-ancestor",
          ]

          activeSelectors.forEach((selector) => {
            const activeItems = document.querySelectorAll(`#top-nav ${selector}`)
            activeItems.forEach((item) => {
              const link = item.querySelector("a:first-child")
              if (link) {
                item.classList.add("has-heading-underline")
                link.classList.add("heading-underline")
              }
            })
          })
        }, delay)
      })
    }
  },

  initToggle() {
    if (!this.toggler) return

    this.toggler.addEventListener("click", (e) => {
      e.preventDefault()

      if (this.mobNav.classList.contains("is-opened")) {
        this.closeAllSubmenus()
      }

      this.toggleClasses(this.mobNav, ["is-opened"])
      this.toggleClasses(this.toggler, ["is-opened"])
      this.mobNav.classList.remove("is-subnav")

      if (this.mobNav.classList.contains("is-opened")) {
        document.body.classList.add("mobile-menu-open")
      } else {
        document.body.classList.remove("mobile-menu-open")
      }
    })
  },

  initZohoMobileChat() {
    this.mobileChatLauncher = document.querySelector(".js-zoho-mobile-chat")

    if (!this.mobileChatLauncher && !document.getElementById("zsiqscript") && !window.$zoho?.salesiq) {
      return
    }

    // Booking pages leave the chat out (footer.php), so its menu button would do nothing there
    if (typeof window.capesLoadChat !== "function" && !document.getElementById("zsiqscript")) {
      this.mobileChatLauncher?.classList.add("hidden")
      return
    }

    this.positionZohoMobileChatLauncher()
    this.bindZohoChatReady()
    this.syncZohoChatButton()

    window.addEventListener("resize", () => {
      this.syncZohoChatButton()
    })

    if (!this.mobileChatLauncher) {
      return
    }

    this.mobileChatLauncher.addEventListener("click", (e) => {
      e.preventDefault()
      this.launchZohoMobileChat()
    })
  },

  positionZohoMobileChatLauncher() {
    if (!this.mobileChatLauncher) {
      return
    }

    const contactLink = Array.from(document.querySelectorAll("#top-right-nav > li > a")).find((link) =>
      link.textContent.trim().toLowerCase() === "contact",
    )
    const contactItem = contactLink?.closest("li")

    if (!contactItem || contactItem.contains(this.mobileChatLauncher)) {
      return
    }

    contactItem.classList.add("mobile-chat-menu-item")
    contactItem.appendChild(this.mobileChatLauncher)
  },

  bindZohoChatReady() {
    if (this.zohoChatReadyBound) {
      return
    }

    window.$zoho = window.$zoho || {}
    window.$zoho.salesiq = window.$zoho.salesiq || {}

    const previousReady = window.$zoho.salesiq.ready

    window.$zoho.salesiq.ready = (...args) => {
      if (typeof previousReady === "function") {
        previousReady.apply(window.$zoho.salesiq, args)
      }

      this.syncZohoChatButton()

      if (this.zohoChatLaunchRequested) {
        this.launchZohoMobileChat()
      }
    }

    this.zohoChatReadyBound = true
  },

  syncZohoChatButton() {
    const floatButton = window.$zoho?.salesiq?.floatbutton

    if (typeof floatButton?.visible !== "function") {
      return false
    }

    floatButton.visible(this.usesMobileHeader() ? "hide" : "show")

    return true
  },

  launchZohoMobileChat() {
    if (!this.usesMobileHeader()) {
      return
    }

    this.zohoChatLaunchRequested = true
    this.closeMobileMenu()
    // The chat only loads once the visitor does something (footer.php), so start it now if it hasn't
    window.capesLoadChat?.()
    this.syncZohoChatButton()

    const floatWindow = window.$zoho?.salesiq?.floatwindow

    if (typeof floatWindow?.visible === "function") {
      floatWindow.visible("show")
      this.zohoChatLaunchRequested = false
      this.zohoChatRetryCount = 0
      window.clearTimeout(this.zohoChatRetryTimeout)
      return
    }

    // 15 seconds, as the chat may only have started loading when the button was tapped. Zoho's
    // ready callback above opens it too, if it arrives first
    if (this.zohoChatRetryCount >= 60) {
      this.zohoChatLaunchRequested = false
      this.mobileChatLauncher?.classList.add("hidden")
      return
    }

    this.zohoChatRetryCount += 1
    window.clearTimeout(this.zohoChatRetryTimeout)
    this.zohoChatRetryTimeout = window.setTimeout(() => {
      this.launchZohoMobileChat()
    }, 250)
  },

  closeAllSubmenus() {
    document.querySelectorAll(".mobile-submenu-open").forEach((submenu) => {
      submenu.classList.remove("mobile-submenu-open")
    })
    document.querySelectorAll(".submenu-open").forEach((item) => {
      item.classList.remove("submenu-open")
    })
  },

  closeMobileMenu() {
    if (!this.mobNav || !this.toggler) {
      return
    }

    this.closeAllSubmenus()
    this.mobNav.classList.remove("is-opened", "is-subnav")
    this.toggler.classList.remove("is-opened")
    document.body.classList.remove("mobile-menu-open")
  },

  initMobileMenu() {
    const menuItemsWithChildren = document.querySelectorAll(".menu-item-has-children")

    menuItemsWithChildren.forEach((item) => {
      const link = item.querySelector("a:first-child")
      const submenu = item.querySelector(".sub-menu")

      if (link && submenu) {
        const originalText = link.textContent.trim()
        const originalHref = link.getAttribute("href")

        link.innerHTML = `
          <span class="menu-text-wrapper" data-href="${originalHref}">${originalText}</span>
          <span class="mobile-chevron-wrapper">
            <img class="mobile-chevron transition-transform duration-300" 
                 src="/wp-content/themes/capes/assets/images/icons/chevron-down.svg" 
                 width="14" height="8" alt="chevron down" loading="lazy">
          </span>
        `

        link.removeAttribute("href")
        link.classList.add("mobile-menu-link")

        const textWrapper = link.querySelector(".menu-text-wrapper")
        textWrapper.addEventListener("click", (e) => {
          e.preventDefault()
          e.stopPropagation()
          if (originalHref && originalHref !== "#") {
            window.location.href = originalHref
          }
        })

        const chevronWrapper = link.querySelector(".mobile-chevron-wrapper")
        chevronWrapper.addEventListener("click", (e) => {
          e.preventDefault()
          e.stopPropagation()

          const isOpen = submenu.classList.contains("mobile-submenu-open")

          document.querySelectorAll(".mobile-submenu-open").forEach((openSubmenu) => {
            if (openSubmenu !== submenu) {
              openSubmenu.classList.remove("mobile-submenu-open")
              openSubmenu.closest(".menu-item-has-children").classList.remove("submenu-open")
            }
          })

          if (isOpen) {
            submenu.classList.remove("mobile-submenu-open")
            item.classList.remove("submenu-open")
          } else {
            submenu.classList.add("mobile-submenu-open")
            item.classList.add("submenu-open")
          }
        })
      }
    })
  },

  isMobile() {
    return window.innerWidth <= 1023
  },

  usesMobileHeader() {
    return window.innerWidth < 1024
  },

  isTablet() {
    return window.innerWidth > 768 && window.innerWidth < 1024
  },

  toggleClasses(el, cls) {
    return cls.map((cl) => el.classList.toggle(cl))
  }
}

// On the document, so it doesn't have to wait for Vue like the menu below
trackClicks()

document.addEventListener("DOMContentLoaded", () => {
  const start = () => {
    CapesHeader.initMenu()
    initBookFloat()
  }

  // Vue rebuilds the header and the page when it starts, so these have to bind to what Vue builds
  if (window.capesAppStartsLate) {
    document.addEventListener("capes:app-started", start, { once: true })
  } else {
    start()
  }
})
